import { PermissionValues as Permissions } from '@gripp/shared-logic';
import { addOnsPaths } from './addOnsPaths';
import { AddOns } from './components/addOns';
import { AddOnsFilterPage } from './components/addOnsFilterPage';

export const addOnsRoutes = [
  {
    path: `${addOnsPaths.root}/filters`,
    element: <AddOnsFilterPage />,
    handle: {
      header: {
        titleKey: 'addOn.list.addOns',
        icon: 'tag',
      },
      requiredPermission: Permissions.globalAdmin,
    },
  },
  {
    path: `${addOnsPaths.root}/*`,
    element: <AddOns />,
    handle: {
      header: {
        titleKey: 'addOn.list.addOns',
        icon: 'tag',
      },
      requiredPermission: Permissions.globalAdmin,
    },
    children: [],
  },
];
